import { showResponseError } from 'utils/messages';
import { trimMoney } from 'utils/strings';
import { reloadOnBackButton } from 'utils/window';
import { setLocation } from 'utils/wrappers';

import Subscription from 'app/models/subscription';

import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize() {
    this.model = new Subscription();
    reloadOnBackButton();
  },

  events: {
    'click #confirm-purchase': 'confirmPurchase',
  },

  context() {
    const {
      id, quantity, interval, name, price,
    } = this.model.get('plan');
    return {
      planId: id,
      planQuantity: quantity,
      planInterval: interval,
      planName: name,
      planPrice: trimMoney(price.toString(), 'USD'),
      proratedFirstPayment: this.model.proratedFirstPayment(),
      nextPaymentDate: this.model.nextPaymentDateFormatted(),
    };
  },

  confirmPurchase() {
    this.model.save(null, {
      success() {
        setLocation('/checkout/success');
      },
      error(model, response) {
        showResponseError(response);
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/checkout_confirmation/index.js